// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"490250f1","655":"d6d6fd58","836":"d6d6fd58","895":"d6d6fd58"}[chunkId] + ".chunk.css";
};